import { render, staticRenderFns } from "./PriceSection.vue?vue&type=template&id=04abc36c&scoped=true&"
import script from "./PriceSection.vue?vue&type=script&lang=js&"
export * from "./PriceSection.vue?vue&type=script&lang=js&"
import style0 from "./PriceSection.vue?vue&type=style&index=0&id=04abc36c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abc36c",
  null
  
)

export default component.exports